<template>
  <v-row>
    <v-col cols="auto" class="pr-3">
      <BaseButton
        color="whiteSmoke"
        width="14"
        height="30"
        icon
        @click="previousStep"
      >
        <v-icon color="primary" size="14"> fa-chevron-left </v-icon>
      </BaseButton>
    </v-col>
    <v-col cols="10">
      <p class="gray--text" style="margin-top: 2px;">
        VOLTAR
      </p>
    </v-col>
    <v-col cols="11">
      <p class="gray--text font-weight-bold quotation-title">
        GRUPO ECONÔMICO
      </p>
    </v-col>
    <v-col cols="12">
      <BaseFormInput
        id-element="selectedGroupEconomicQuotation"
        v-model="form.economicGroup.nome"
        disabled
        label-text="Grupo Econômico"
      />
    </v-col>
    <v-col cols="12">
      <BaseFormInput
        id-element="selectedTakerQuotation"
        v-model="form.taker.nome_fantasia"
        disabled
        label-text="Tomador Matriz/Filial"
      />
    </v-col>
    <v-col cols="12" class="pb-8">
      <v-divider />
    </v-col>
  </v-row>
</template>
<script>
export default {
  methods: {
    previousStep() {
      this.$emit("return");
    }
  },
  props: {
    form: {
      type: Object
    }
  }
};
</script>
<style lang="sass"></style>
